module.exports = __webpack_public_path__ + "static/media/napa.5c5ac5f3.jpg";